var _path, _circle, _circle2, _path2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTabRiskFactorsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M10 16.2c-5.3-3.8-6.9-6.9-6.9-9.1a3.1 3.1 0 0 1 5.6-1.7L10 6.7l1.3-1.3A3.1 3.1 0 0 1 17 7.1c0 2.1-1.5 5.2-7 9.1Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 14.7,
  cy: 14.4,
  r: 4.5,
  fill: "#fff",
  stroke: "none"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.7,
  cy: 14.4,
  r: 3.5,
  fill: "#087E8B",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.15,
  d: "M14.7 12.5v2.05"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.7,
  cy: 16.2,
  r: 0.62,
  fill: "#fff",
  stroke: "none"
})));
export default SvgTabRiskFactorsIcon;